export default {
	methods: {
		getPurchasedCollectibles: function () {
			axios.get(route('nft.purchased.collectibles')).then((response) => {
				this.ownedCollectibles.pieces = response.data.accountNfts
				this.ownedCollectibles.rows = response.data.rows
				this.soldCollectibles = response.data.soldCollectibles
				this.ownedCollectibles.pieces.sort((a, b) => {
					return a.NFTokenTaxon - b.NFTokenTaxon
				})
			})
		},

		checkIfPieceSoldAtPrimaryMarket: function (nftTokenId) {
			axios.get(route('check-collectible-primary-market-status', nftTokenId)).then((response) => {
				this.soldAtPrimaryMarket = response.data
			}).catch(error => {
				//
			})
		},

		getTokens: function () {
			this.loadingBalances = true
			axios.get(`${route('user.tokens')}`).then(response => {
				this.tokens = response.data
				this.loadingBalances = false
			}).catch(error => {
				Toast.fire({'icon': 'error', 'title': 'Something went wrong! Refresh the page and try again.'})
				this.loadingBalances = false
			})
		},
	}
}
